<template>
  <div></div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    action() {
      return 'create'
    },
    submitUri() {
      return `base-cost/create`
    }
  },
  created() {
    this.submit()
  },
  methods: {
    submit() {
      this.submitForm(
        this.data,
        {
          done: (response) => {
            if (!_.isUndefined(response.id)) {
              this.$emitter.emit('Modal', {
                name: 'base-cost.edit',
                data: {
                  _id: response.id
                }
              })
            }
          }
        },
        {
          $el: document.body
        }
      )
    }
  },
  props: {
    config: Object
  }
}
</script>
